import * as React from "react";
import {
  Datagrid,
  List,
  Show,
  Create,
  ImageField,
  ImageInput,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  RichTextField,
  FileInput,
  FileField,
  Edit,
  ReferenceField,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";

export const ContentList = (props) => (
  <List
    {...props}
  >
    <Datagrid>
      <TextField source="title" label="Titre" />
      <ReferenceField source="category" reference="categories" label="Categorie">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="description" label="Description" />
      <ImageField source="thumbnail.src" label="Miniature">
      </ImageField>
      <TextField source="createdby" label="Créer par" />

      <DeleteButton label="" redirect={false} />
      <EditButton label="" />
      <ShowButton />

    </Datagrid>
  </List>
);

// const ConditionalEmailField = ({}) =>
//   record && record.hasEmail ? (
//     <EmailField source="email" record={record} {...rest} />
//   ) : null;
export const ContentShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="title" label="Titre" />
      <ImageField source="thumbnail.src" label="Miniature"></ImageField>
      <RichTextField source="description" label="Description" />
      <ReferenceField source="category" reference="categories" label="Categorie">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="createdby" label="Créer par" />
      <RichTextField source="description" />

    </SimpleShowLayout>
  </Show>
);

export const ContentCreate = (props) => (

  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" label="titre" />
      <ImageInput source="thumbnail" label="Miniature" >
        <ImageField source="src" title="Miniature" />
      </ImageInput>
      <TextInput source="description" label="Description" />
      <ReferenceInput source="category" reference="categories" label="Categorie" >
        <AutocompleteInput optionText="name" label="Categorie" />
      </ReferenceInput>
      <FileInput source="video" label="Fichier video">
        <FileField source="src" title="Video" />
      </FileInput>
    </SimpleForm>
  </Create>
);

export const ContentEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title" label="titre" />
      <ImageInput source="thumbnail" label="Miniature" >
        <ImageField source="src" title="Miniature" />
      </ImageInput>
      <TextInput source="description" label="Description" />
      <ReferenceInput source="category" reference="categories" label="Categorie" >
        <AutocompleteInput optionText="name" label="Categorie" />
      </ReferenceInput>
      <FileInput source="video" label="Fichier video">
        <FileField source="src" title="Video" />
      </FileInput>
    </SimpleForm>
  </Edit>
);
